import { createContext, useContext } from 'react';

import type { LearnerProfile_LearningGoal as LearningGoal } from '__generated__/graphql-types';
import type { Skill_CareerRole } from '__generated__/graphql-types-do-not-use';

export type SkillRole = Pick<Skill_CareerRole, 'id' | 'name' | 'slug'>;
export type LearnerProfileRole = SkillRole | string;

type LearnerProfileContextType = {
  roles?: Array<LearnerProfileRole>;
  skillRoles?: Array<SkillRole>;
  learningGoal?: LearningGoal;
  isLearnerProfileLoading: boolean;
  isVerifiedUser: boolean;
  userVerificationDataLoading: boolean;
};

const LearnerProfileContext = createContext<LearnerProfileContextType | undefined>(undefined);

export const useLearnerRoles = () => {
  const learnerProfileContext = useContext(LearnerProfileContext);

  return learnerProfileContext?.roles;
};

export const useSkillRoles = () => {
  const learnerProfileContext = useContext(LearnerProfileContext);

  return learnerProfileContext?.skillRoles;
};

export const useLearnerGoal = () => {
  const learnerProfileContext = useContext(LearnerProfileContext);

  return learnerProfileContext?.learningGoal;
};

export const useIsLearnerProfileLoading = () => {
  const learnerProfileContext = useContext(LearnerProfileContext);

  return learnerProfileContext?.isLearnerProfileLoading;
};

export const useLearnerVerificationState = () => {
  const learnerProfileContext = useContext(LearnerProfileContext);

  return {
    isVerifiedUser: learnerProfileContext?.isVerifiedUser,
    userVerificationDataLoading: learnerProfileContext?.userVerificationDataLoading,
  };
};

export default LearnerProfileContext;
